import { updateItemInCollection } from "directus/src/operations";

export async function updateSkill({ item, skillId }) {
  try {
    const data = await updateItemInCollection("skills", skillId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
